import { createFileRoute } from "@tanstack/react-router";
import { CyclePage } from "../../../../features/projects/CyclePage";
import { validateCycleSearch } from "../../../../features/projects/chapterSearch";

export const Route = createFileRoute("/_app/projects/$projectId/cycle")({
  validateSearch: validateCycleSearch,
  component: function Cycle() {
    const { projectId } = Route.useParams();
    const { chapter, apply } = Route.useSearch();
    return <CyclePage key={projectId} projectId={projectId} chapter={chapter} apply={apply} />;
  },
});
